<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="isLogged"
    >
      <v-sheet
        color="grey lighten-4"
        class="pa-4"
      >

        <div>{{getUser.email}}</div>
        <v-btn 
        class="mt-2"
        elevation="1"
        @click="confirmLogout() && logout()"
        >
          Logout
        </v-btn>
      </v-sheet>

      <v-divider></v-divider>

    <v-list>
      <v-list-item-group>
        <v-list-item
          v-for="text in getMenu"
          :key="text.name"
          :to="`/${text.name.toLowerCase()}`"
          link
          @click="active = text.id"
          active-class="green accent-1"
        >
          <v-icon small class="mr-4 ml-4" :color="active === text.id ? 'green' : 'gray'">mdi-circle</v-icon>
          <v-list-item-content
            v-text="text.name"
          >
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    </v-navigation-drawer>
    <v-app-bar 
      v-if="isLogged" 
      app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Menu</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container
        class="py-8 px-6"
        fluid
      >
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: null,
      active: null,
      sections: [
        {id: 1, name: 'Projects', type: 1},
        {id: 2, name: 'Datasets', type: 1},
        {id: 3, name: 'Activities', type: 3},
        {id: 4, name: 'Publications', type: 2},
        {id: 5, name: 'Categories', type: 2},
        {id: 6, name: 'Resources', type: 2},
        {id: 7, name: 'Members', type: 2},
        {id: 8, name: 'Users', type: 1},
      ]
    }),
    computed: {
      getMenu: function(){
        return this.sections.filter(a => a.type >= JSON.parse(localStorage.getItem('user')).userType)
      },
      getUser: function(){
        return JSON.parse(localStorage.getItem('user'))
      },
      isLogged: function(){
        return !!localStorage.getItem('token')
                && !!localStorage.getItem('user')
      }
    },
    watch : {
      active: function(){
        console.log(this.active)
      }
    },
    methods: {
      confirmLogout(){
        return confirm("Are you sure you want to logout?");
      },

      logout() {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.$router.push({name: 'Login'})
        this.$router.go()
      }
    }
  }
</script>